import { EditableText, type EditableTextProps } from "@/components/forms/EditableText.tsx";
import { DetailsTableRow, type DetailsTableRowProps } from "@/components/table/DetailsTableRow.tsx";
import { Trans, useLingui } from "@lingui/react/macro";

export interface DetailsTableNameProps extends Omit<
    EditableTextProps,
    "defaultValue" | "defaultIsEditing" | "validate"
> {
    title?: DetailsTableRowProps["title"];
}

export function DetailsTableName({ title = <Trans>Name</Trans>, ...editableProps }: DetailsTableNameProps) {
    const { t } = useLingui();

    return (
        <DetailsTableRow title={title}>
            <EditableText placeholder={t`Add name`} {...editableProps} />
        </DetailsTableRow>
    );
}
